import { Entity } from '@api';
import { useEarningsInsightsByEarningsId } from '@terminal/react-query-hooks/insights/useEarningsInsightsByEarningsId';

import { useEarningsStore } from '../../useEarningsStore/useEarningsStore';
import { getColumns } from '../../utils/tableUtils';
import { EarningsTable } from '../earnings-table/EarningsTable';

interface EarningsTableWrapperProps {
  isError: boolean;
  isRefetchError: boolean;
  entity: Entity;
  error: Error | null;
}

export const EarningsTableWrapper = ({
  isError,
  isRefetchError,
  entity,
  error,
}: EarningsTableWrapperProps) => {
  const {
    rowSelection,
    updateRowSelection,
    getIsAllRowsSelected,
    getIsSomeRowsSelected,
    toggleAllRowsSelection,
    getIsRowManualChanged,
    getIsRowMatchingFilters,
    earningsData,
  } = useEarningsStore();

  const { earningsInsightByEarningsId, isEarningsInsightsFetching } =
    useEarningsInsightsByEarningsId({
      earningsIds: earningsData.map(earning => earning.id),
    });

  const columns = getColumns({
    getIsAllRowsSelected,
    getIsSomeRowsSelected,
    toggleAllRowsSelection,
    updateRowSelection,
    rowSelection,
    getIsRowManualChanged,
    getIsRowMatchingFilters,
    earningsData,
    earningsInsightByEarningsId,
    isEarningsInsightsFetching,
  });

  if (isError || isRefetchError) {
    throw new Error(error?.message);
  }

  return (
    <EarningsTable
      columns={columns}
      entity={entity}
      earningsInsightByEarningsId={earningsInsightByEarningsId}
    />
  );
};
